import { toast } from "react-toastify";
import { api } from "./api.config";
import * as XLSX from "xlsx";

export const loginUser = async (data) => {
  console.log("data: ", data);
  try {
    const response = await api.post(`/user_login`, data);
    // console.log("response: ", response.data);

    if (response.status === 200 && response.data.token) {
      const token = response.data.token;

      const expiresAt = new Date();
      expiresAt.setDate(expiresAt.getDate() + 1);

      if (response.data.department !== "admin") {
        localStorage.setItem("token", token);
        localStorage.setItem("role", "user");
        localStorage.setItem("expires_at", expiresAt.toISOString());
        window.location.href = "/";
      }

      if (response.data.department === "admin") {
        localStorage.setItem("token", token);
        localStorage.setItem("role", "admin");
        localStorage.setItem("expires_at", expiresAt.toISOString());
        window.location.href = "/";
      }
    }
    return response.data;
  } catch (err) {
    console.log("Error (loginUser): ", err);
    throw err;
  }
};

export const costomerLoginApi = async (data) => {
  // console.log("data: ", data);
  try {
    const response = await api.post(`/customer/login`, data);
    console.log("response: ", response.data);

    if (response.status === 200 && response.data.token) {
      const token = response.data.token;

      const expiresAt = new Date();
      expiresAt.setDate(expiresAt.getDate() + 1);

      // if (response.data.department !== "customer") {
      //   localStorage.setItem("token", token);
      //   localStorage.setItem("role", "user");
      //   localStorage.setItem("expires_at", expiresAt.toISOString());
      //   window.location.href = "/";
      // }

      if (response.data.department === "customer") {
        localStorage.setItem("token", token);
        localStorage.setItem("role", "customer");
        localStorage.setItem("expires_at", expiresAt.toISOString());
        window.location.href = "/customer/addorder";
      }
    }
    return response.data;
  } catch (err) {
    console.log("Error (loginUser): ", err);
    throw err;
  }
};

export const createUser = async (data) => {
  try {
    const response = await api.post(`/admin/add_user`, data);
    // console.log("response: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (createUser): ", err);
    throw err;
  }
};

// get user data by it's id
export const getUserById = async (id) => {
  try {
    const response = await api.post(`/admin/edit_user`, { id });
    console.log("response: ", response.data);
    return response.data;
  } catch (err) {
    console.log("Error (getUserById): ", err);
    throw err;
  }
};

export const getUsers = async (pageSize, page) => {
  try {
    const response = await api.post(`/user`, null, {
      params: { pageSize, page },
    });
    console.log("response: ", response.data);
    return response.data;
  } catch (err) {
    console.log("Error (getUsers): ", err);
    throw err;
  }
};

// update user by user id
export const updateUserById = async (data) => {
  try {
    const response = await api.post(`/admin/update_user`, {
      ...data,
    });
    console.log("response: ", response.data);
    return response.data;
  } catch (err) {
    console.log("Error (updateUserById): ", err);
    throw err;
  }
};

// update user permissions by user id
export const updateUserPermissions = async (data) => {
  try {
    console.log("data: ", data);
    const response = await api.post(`/admin/update_user_permission`, data);
    console.log("response: ", response.data);
    return response.data;
  } catch (err) {
    console.log("Error (updateUserPermissions): ", err);
    throw err;
  }
};

export const updateUser = async (data) => {
  try {
    const response = await api.post(`/admin/update_user`, data);
    console.log("response: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (updateUser): ", err);
    throw err;
  }
};

// get Customer with pagination
export const getCustomers = async (pageSize, page) => {
  try {
    const response = await api.get(`/customer`, {
      // <-- Ensure no extra space
      params: { pageSize, page },
    });
    console.log("response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching customers:", error);
    throw error;
  }
};
// create Customer
export const addCustomer = async (customerData) => {
  try {
    const response = await api.post("admin/add_customer", customerData);
    return response.data;
  } catch (error) {
    console.error("Error adding customer:", error);
    throw error;
  }
};

// get Customer by id

export const getCustomerById = async (id, masterId) => {
  try {
    const response = await api.post(`/admin/edit_customer`, {
      id,
      master_id: masterId,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching customer:", error);
    throw error;
  }
};

// update Customer

export const updateCustomer = async (customerData) => {
  try {
    const response = await api.post(`/admin/update_customer`, customerData);
    return response.data;
  } catch (error) {
    console.error("Error updating customer:", error);
    throw error;
  }
};

// Delete Customer

export const deleteCustomer = async (id, masterId) => {
  try {
    await api.post(`/admin/delete_customer`, { id, master_id: masterId });
  } catch (error) {
    console.error("Error deleting customer:", error);
    throw error;
  }
};

export const deleteUser = async (id) => {
  try {
    // console.log("id: ", id);
    const response = await api.post(`/delete_user`, { id });
    console.log("response delete: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (updateUser): ", err);
    throw err;
  }
};

// Get Colors
export const getColors = async (pageSize, page) => {
  try {
    const response = await api.get(`/color`, {
      params: { pageSize, page },
    });
    console.log("response: ", response.data);
    return response.data;
  } catch (err) {
    console.log("Error (getColors): ", err);
    throw err;
  }
};

// Add Color

export const addColor = async (color) => {
  try {
    const response = await api.post(`/admin/add_color`, color);
    console.log("colorResponse:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error adding color:", error);
    throw error;
  }
};

// get Color By Id Color
export const getColorById = async (id, masterId) => {
  try {
    const response = await api.post(`/admin/edit_color`, {
      id,
      master_id: masterId,
    });
    console.log("colorResponse:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating color:", error);
    throw error;
  }
};

// update Color
export const updateColor = async (updatedData) => {
  try {
    const response = await api.post(`/admin/update_color`, updatedData);
    console.log("colorResponse:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating color:", error);
    throw error;
  }
};

// Delete Color

export const deleteColor = async (id, masterId) => {
  try {
    const response = await api.post(`/admin/delete_color`, {
      id,
      masterid: masterId,
    });
    console.log("Delete response:", response); // Log response to debug
    return response;
  } catch (error) {
    console.error("Error deleting color:", error.response?.data || error);
    throw error;
  }
};

// Get Series

export const getSeries = async (pageSize, page) => {
  try {
    const response = await api.post(`/product`, { page, pageSize });
    console.log("response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error adding color:", error);
    throw error;
  }
};

// Add Series

export const addSeries = async (series) => {
  try {
    const response = await api.post(`/admin/add_product`, series);
    console.log("Series Response :", response.data);
    return response.data;
  } catch (error) {
    console.error("Error adding color:", error);
    throw error;
  }
};

// get Series By Id
export const getSeriesById = async (id, masterId) => {
  try {
    const response = await api.post(`/admin/edit_product`, {
      id,
      master_id: masterId,
    });
    console.log("colorResponse:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating color:", error);
    throw error;
  }
};

// update Series
export const updateSeries = async (id, masterId, prodName, product_type) => {
  try {
    const response = await api.post(`/admin/update_product`, {
      id,
      masterId,
      prodName,
      product_type,
    });
    console.log("colorResponse:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating color:", error);
    throw error;
  }
};

// delete Series
export const deleteSeries = async (id, masterId) => {
  try {
    const response = await api.post(`/admin/delete_product`, { id, masterId });
    console.log("colorResponse:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error deleting color:", error);
    throw error;
  }
};

// get Series Design By Id

export const getSeriesDesignById = async (id, masterId, page, pageSize) => {
  try {
    const response = await api.post("/productdetails", {
      series_id: id,
      master_id: masterId,
      page: page,
      pageSize: pageSize,
    });
    console.log("colorResponse:", response.data);
    return response.data; // 🔥 this line was missing
  } catch (error) {
    console.error("Error updating color:", error);
    throw error;
  }
};

// add design
export const addDesign = async (design) => {
  try {
    const response = await api.post("/admin/adddesign", design);
    console.log("colorResponse:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error adding design:", error);
    throw error;
  }
};

// edit Design

export const editDesign = async (master_id, id, product_id) => {
  try {
    const response = await api.post(`/admin/edit_product_design`, {
      master_id,
      id,
      product_id,
    });
    console.log("colorResponse:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating design:", error);
    throw error;
  }
};

// update design
export const updateDesign = async (design) => {
  try {
    const response = await api.post("/admin/update_product_design", design);
    console.log("colorResponse:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating design:", error);
    throw error;
  }
};

// delete Design

export const deleteDesign = async (master_id, seriesId, designId) => {
  try {
    const response = await api.post(`/admin/delete_product_design`, {
      master_id,
      seriesId,
      designId,
    });
    console.log("colorResponse:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating design:", error);
    throw error;
  }
};

export const updateUserPassword = async (data) => {
  try {
    const response = await api.post(`/admin/update_user_password`, data);
    console.log("response: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (updateUserPassword): ", err);
    throw err;
  }
};

// Order Management

// get customer data for order
export const getCustomerDataForOrder = async (value) => {
  try {
    const response = await api.post(`/admin/get_customerData`, { value });
    console.log("response: ", response.data);
    return response.data;
  } catch (err) {
    console.log("Error (getCustomerDataForOrder): ", err);
    throw err;
  }
};

// update order data
export const updateOrderData = async (data) => {
  try {
    const response = await api.post(`/admin/update_order`, data);
    console.log("response: ", response.data);
    return response.data;
  } catch (err) {
    console.log("Error (updateOrderData): ", err);
    throw err;
  }
};

// delete order
export const deleteOrder = async (neworderid) => {
  try {
    const response = await api.post(`/admin/delete_order`, {neworderid});
    console.log("response: ", response.data);
    return response.data;
  } catch (err) {
    console.log("Error (deleteOrder): ", err);
    throw err;
  }
};

// order search
export const orderSearch = async (data) => {
  try {
    const response = await api.post(`/admin/order/filter`, data);
    console.log("response: ", response.data);
    return response.data;
  } catch (err) {
    console.log("Error (orderSearch): ", err);
    throw err;
  }
};

// get desing data for order
export const getDesignDataForOrder = async (DesginId) => {
  try {
    const response = await api.post(`/admin/get_designData`, { DesginId });
    console.log("response: ", response.data);
    return response.data;
  } catch (err) {
    console.log("Error (getDesignDataForOrder): ", err);
    throw err;
  }
};

// get product data for order
export const getProductDataForOrder = async () => {
  try {
    const response = await api.get(`/admin/searchproductdata`);
    console.log("response: ", response.data);
    return response.data;
  } catch (err) {
    console.log("Error (getProductDataForOrder): ", err);
    throw err;
  }
};

// update order stauts
export const updateOrderStatus = async (data) => {
  try {
    const response = await api.post(`/admin/update_order_status`, data);
    console.log("response: ", response.data);
    return response.data;
  } catch (err) {
    console.log("Error (updateOrderStatus): ", err);
    throw err;
  }
};

// Upload order image/PDF
export const uploadOrderFile = async (file, orderData = null) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    
    // If order data is provided, include it in the request
    if (orderData) {
      if (orderData.neworderid) {
        formData.append("neworderid", orderData.neworderid);
      }
      if (orderData.product_id) {
        formData.append("product_id", orderData.product_id);
      }
    }

    const response = await api.post("/admin/uploadOrderImage", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    
    console.log("File Upload Response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
};

// Delete order image/PDF from temp folder
export const deleteOrderFile = async (filePath) => {
  try {
    const response = await api.post("/admin/deleteOrderImage", {
      path: filePath,
    });
    
    console.log("File Delete Response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error deleting file:", error);
    throw error;
  }
};

export const createNewOrder = async (orderData) => {
  try {
    const response = await api.post("/admin/addOrder", orderData);
    console.log("Order Response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error creating order:", error);
    throw error;
  }
};

export const getOrderList = async (pageSize, page) => {
  try {
    console.log("pageSize: ", pageSize);
    console.log("page: ", page);
    const response = await api.post("/order", { pageSize, page });
    console.log("Order List : ", response.data);
    return response.data;
  } catch (error) {
    console.log("Error (getOrderList): ", error);
    throw error;
  }
};


export const getOrderforDeliveryslipList = async (pageSize, page) => {
  try {
    console.log("pageSize: ", pageSize);
    console.log("page: ", page);
    const response = await api.post("/deliveryslip/order", { pageSize, page });
    console.log("Order List : ", response.data);
    return response.data;
  } catch (error) {
    console.log("Error (getOrderforDeliveryslipList): ", error);
    throw error;
  }
};
// View Invaentory management

export const getInventory = async (page, pageSize) => {
  try {
    const inventoryResponse = await api.post("/inventory", { pageSize, page });
    console.log("Inventory view data:", inventoryResponse.data);
    return inventoryResponse.data;
  } catch (error) {
    console.error("Inventory view data error:", error);
    throw error;
  }
};

// Add Inventory

export const addInventory = async (inventoryData) => {
  try {
    const response = await api.post("/admin/add_inventory", inventoryData);
    console.log("Inventory Response :", response.data);
    return response.data;
  } catch (error) {
    console.error("Error adding Inventory:", error);
    throw error;
  }
};

// get Inventory By Id
export const editInventoryById = async (masterId, id) => {
  try {
    const response = await api.post(`/admin/edit_inventory`, {
      id: id,
      master_id: masterId,
    });
    console.log("Inventory Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating Inventory:", error);
    throw error;
  }
};

// update Inventory
export const updateInventory = async (inventoryData) => {
  try {
    const response = await api.post(`/admin/update_inventory`, inventoryData);
    console.log("Inventory Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating Inventory:", error);
    throw error;
  }
};
export const updateInventoryQuantity = async (payload) => {
  // // Example implementation
  // return await fetch(`/api/inventory/${id}/quantity`, {
  //   method: "PUT",
  //   headers: { "Content-Type": "application/json" },
  //   body: JSON.stringify({ quantity }),
  // });
  try {
    const response = await api.post(
      `/admin/update_inventory_plusandminus`,
      payload
    );
    console.log("updateInventoryQuantity Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating Inventory Quantity:", error);
    throw error;
  }
};

// Delete Inventory
export const deleteInventory = async (id, masterId) => {
  try {
    const response = await api.post(`/admin/delete_inventory`, {
      id: id,
      master_id: masterId,
    });
    console.log("Delete response:", response); // Log response to debug
    return response;
  } catch (error) {
    console.error("Error deleting Inventory:", error.response?.data || error);
    throw error;
  }
};
// get color name for new order
export const getColorNameForNewOrder = async () => {
  try {
    const response = await api.post(`/admin/find_color`);
    console.log("response: ", response.data);
    return response.data;
  } catch (err) {
    console.log("Error (getColorNameForNewOrder): ", err);
    throw err;
  }
};

// Update Order Status
export const updateStatusForOrder = async (
  orderId,
  oldstatus,
  newstatus,
  partialDispatchData,
  dispatchRemark,
  attachments,
  neworderid,
  dispatchDate
) => {
 
  try {
    // const response = await api.post("/orders/update_status", {
    if (newstatus === "dispatch") {
      const response = await api.post("/admin/updateStatus", {
        id: orderId,
        neworderid,
        oldstatus,
        newstatus,
        dispatchRemark,
        dispatchDate,
        files: attachments,
      });
      return response.data;
    }
    // Then handle partial dispatch
    else if (newstatus === "partialdispatch" || newstatus === "processing") {
      const payload = {
        id: orderId,
        neworderid,
        oldstatus,
        newstatus,
        notes: partialDispatchData.notes,
        vehicle_number: partialDispatchData.vehicleDetails.vehicleNumber,
        vehicle_type: partialDispatchData.vehicleDetails.vehicleType,
        dispatcher_name: partialDispatchData.vehicleDetails.dispatcherName,
        receiver_name: partialDispatchData.vehicleDetails.driverName,
        value: partialDispatchData.vehicleDetails.value, // ✅ added
        products: partialDispatchData.products.map((p) => ({
          product_id: p.product_id,
          updateQuanInPic: Number(p.updateQuanInPic),
        })),
      };
      const response = await api.post("/admin/updateStatus", payload);
      return response.data;
    }
    // Finally handle other statuses
    else {
      const response = await api.post("/admin/updateStatus", {
        id: orderId,
        neworderid,
        oldstatus,
        newstatus,
      });
      return response.data;
    }
  } catch (error) {
    console.error("Error updating order status:", error);
    throw error;
  }
};

// Get Molds
export const getMolds = async (page, pageSize) => {
  try {
    const response = await api.post("/molds", { pageSize, page });
    console.log("Molds data:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching molds:", error);
    throw error;
  }
};
// Add Mold
export const addMold = async (moldData) => {
  try {
    // Transform the payload to match the backend's expected structure
    const transformedData = {
      mold_name: moldData.moldName,
      mold_packaging_size: moldData.packagingSize,
      mold_quantity: String(moldData.quantity), // Convert to string
      mold_remaining_quantity: String(moldData.quantity), // Set equal to quantity
      ...(moldData.costPerUnit !== undefined && moldData.costPerUnit !== "" && {
        cost_per_unit: moldData.costPerUnit,
      }),
    };

    // Use the correct endpoint
    const response = await api.post("admin/add_molds", transformedData);
    console.log("Mold Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error adding mold:", error);
    throw error;
  }
};

// Get Mold By Id
export const editMoldById = async (id, masterId) => {
  try {
    const response = await api.post(`/admin/edit_mold`, {
      id,
      master_id: masterId,
    });
    console.log("Edit Mold API Full Response:", response); // Log full response
    console.log("Response Data:", response.data); // Log data specifically
    return response.data;
  } catch (error) {
    console.error("Error fetching mold:", error);
    throw error;
  }
};
// Update mold data
export const updateMold = async (updatedData) => {
  try {
    const response = await api.post(`/admin/update_mold`, updatedData);
    console.log("Update Mold API Full Response:", response); // Log full response
    console.log("Response Data:", response.data); // Log data specifically
    return response.data;
  } catch (error) {
    console.error("Error updating mold:", error);
    throw error;
  }
};

// Update Mold Quanti
export const updateMoldQuantity = async (payload) => {
  try {
    const response = await api.post(`/admin/update_mold_plusandminus`, payload);
    console.log("Quantity update response:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "Error updating mold quantity:",
      error.response?.data || error.message
    );
    throw error;
  }
};
// Delete Mold
export const deleteMold = async (id, masterId) => {
  try {
    const response = await api.post("/admin/delete_mold", {
      id: id,
      master_id: masterId,
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting mold:", error);
    throw error;
  }
};
export const searchUsers = async (searchQuery, pageSize, page) => {
  try {
    const response = await api.get(`/admin/search_user`, {
      params: {
        search: searchQuery,
        pageSize,
        page,
      },
    });
    return response.data;
  } catch (err) {
    console.error("Error (searchUsers):", err);
    throw err;
  }
};

export const searchInventory = async (searchQuery, pageSize, page) => {
  try {
    const response = await api.post("/admin/search-inventory", {
      search: searchQuery,
      pageSize,
      page,
    });
    return response.data;
  } catch (err) {
    console.error("Error (searchInventory):", err);
    throw err;
  }
};

export const searchMolds = async (searchQuery, pageSize, page) => {
  try {
    const response = await api.post("/admin/search-mold", {
      search: searchQuery,
      pageSize,
      page,
    });
    return response.data;
  } catch (err) {
    console.error("Error (searchMolds):", err);
    throw err;
  }
};
export const searchCustomers = async (searchQuery, pageSize, page) => {
  try {
    const response = await api.post("/admin/search-customer", {
      search: searchQuery,
      pageSize,
      page,
    });
    return response.data;
  } catch (err) {
    console.error("Error (searchCustomers):", err);
    throw err;
  }
};

export const searchColors = async (searchQuery, pageSize, page) => {
  try {
    const response = await api.post("/admin/search-color", {
      search: searchQuery,
      pageSize,
      page,
    });
    return response.data;
  } catch (err) {
    console.error("Error (searchColors):", err);
    throw err;
  }
};

export const searchSeries = async (searchQuery, pageSize, page) => {
  try {
    const response = await api.post("/admin/search-product", {
      search: searchQuery,
      pageSize,
      page,
    });
    return response.data;
  } catch (err) {
    console.error("Error (searchSeries):", err);
    throw err;
  }
};

// update qty in order
export const updateQTY = async (data) => {
  try {
    const response = await api.post("/admin/order/product/update-qty", data);
    console.log("Order Qty Response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating order qty:", error);
    throw error;
  }
};

export const getDispatchOrders = async (page, pageSize) => {
  try {
    const response = await api.post("/admin/dispatch-orders", {
      pageSize,
      page,
    });
    console.log("Dispatch Orders Response: ", response.data);
    return response.data;
  } catch (error) {
    console.log("Error (getDispatchOrders): ", error);
    throw error;
  }
};

// view dispatch order

export const viewDispatchOrder = async (page, pageSize) => {
  try {
    const response = await api.post("/admin/view-dispatch-orders", {
      page,
      pageSize,
    });
    console.log("Dispatch Order Response: ", response.data);
    return response.data;
  } catch (error) {
    console.log("Error (viewDispatchOrder): ", error);
    throw error;
  }
};

// update Dispatch Date Office

export const updateDispatchDateOffice = async (
  neworderid,
  tentative_date,
  id
) => {
  try {
    const response = await api.post("/admin/update-tentative-date", {
      neworderid,
      tentative_date,
      id,
    });
    console.log("Order update Dispatch Date Office  : ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating  Dispatch Date Office:", error);
    throw error;
  }
};

// get deleted orders
export const getDeletedOrders = async (page, pageSize) => {
  try {
    const response = await api.post("/admin/deleted-orders", {
      pageSize,
      page,
    });
    console.log("Deleted Orders Response: ", response.data);
    return response.data;
  } catch (error) {
    console.log("Error (getDeletedOrder): ", error);
    throw error;
  }
};

// for recovering the order
export const recoverOrder = async (neworderid, id) => {
  try {
    const response = await api.post("/admin/recover-deleted-order", {
      neworderid,
      id,
    });
    return response.data;
  } catch (error) {
    console.log("Error (recoverOrder): ", error);
    throw error;
  }
};

// update Dispatch Date Production
export const updatedispatchdateproduction = async (
  neworderid,
  dispatch_date_production,
  id
) => {
  try {
    const response = await api.post("/admin/update-dispatch-production-date", {
      neworderid,
      dispatch_date_production,
      id,
    });
    console.log("Order update Dispatch Date Office  : ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating  Dispatch Date Office:", error);
    throw error;
  }
};

// update Dispatch Remark
export const updateDispatchRemark = async (
  neworderid,
  dispatch_remarks,
  id
) => {
  try {
    const response = await api.post("/admin/update-dispatch-remarks", {
      neworderid,
      dispatch_remarks,
      id,
    });
    console.log("Order update Dispatch Date Office  : ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating  Dispatch Date Office:", error);
    throw error;
  }
};

//   update Dispatch Order Status
export const updateDispatchOrderStatus = async (neworderid, status, id) => {
  try {
    const response = await api.post("/admin/update-dispatch-status", {
      neworderid,
      status,
      id,
    });
    console.log("Order update Dispatch Date Office  : ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating  Dispatch Date Office:", error);
    throw error;
  }
};

// get Cancelled Orders
export const viewCancelledData = async (page, pageSize) => {
  try {
    const response = await api.post("/admin/view-cancelled-orders", {
      page,
      pageSize,
    });

    console.log("Cancelled Order Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching cancelled orders:", error);
    throw error;
  }
};

// update Cancelled Order Status

export const updateCancledOrderStatus = async (neworderid, status, id) => {
  try {
    const response = await api.post("/admin/update-cancelled-status", {
      neworderid,
      status,
      id,
    });
    console.log("Order update Dispatch Date Office  : ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating  Dispatch Date Office:", error);

    throw error;
  }
};
export const searchDispatchOrders = async (searchQuery, pageSize, page) => {
  try {
    const response = await api.post("/admin/disptch/search", {
      search: searchQuery,
      pageSize,
      page,
    });
    return response.data;
  } catch (err) {
    console.error("Error (searchDispatchOrders):", err);
    throw err;
  }
};
export const searchCancelledOrders = async (searchQuery, pageSize, page) => {
  try {
    const response = await api.post("/search_cancel", {
      search: searchQuery,
      pageSize,
      page,
    });
    return response.data;
  } catch (err) {
    console.error("Error searching cancelled orders:", err);
    throw err;
  }
};

export const searchDeletedOrders = async (searchQuery, pageSize, page) => {
  try {
    const response = await api.post("/admin/search-deleted-orders", {
      search: searchQuery,
      pageSize,
      page,
    });
    return response.data;
  } catch (err) {
    console.error("Error searching deleted orders:", err);
    throw err;
  }
};

// Revert Inventory Data

export const revertInventoryData = async (payload) => {
  try {
    const response = await api.post("/admin/revert_inventryquantity", payload);
    console.log("Revert Inventory Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error reverting inventory data:", error);
    throw error;
  }
};

// In your contextsApi.js or equivalent API file
export const revertMoldQuantity = async (payload) => {
  try {
    const response = await api.post("/admin/revert_quantity", payload);
    console.log("Revert Mold Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error reverting mold quantity:", error);
    throw error;
  }
};

// Edit Order By Id
export const editOrderById = async (id, master_id) => {
  try {
    const response = await api.post("/admin/edit_order", { id, master_id });
    console.log("Edit Order Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error editing order:", error);
    throw error;
  }
};
export const getOrdersByNewOrderId = async (neworderid) => {
  try {
    const response = await api.post(`/admin/get-orders-by-neworderid`, {
      neworderid,
    });
    console.log("getOrdersByNewOrderId response: ", response.data);
    return response.data;
  } catch (err) {
    console.error("Error (getOrdersByNewOrderId): ", err);
    throw err;
  }
};

export const fetchParsialDipatchData = async (neworderid) => {
  try {
    const response = await api.post(`/admin/products-with-update`, {
      neworderid,
    });
    console.log("fetchParsialDipatchData response: ", response.data);
    return response.data;
  } catch (err) {
    console.error("Error (fetchParsialDipatchData): ", err);
    throw err;
  }
};

export const getAllQueue = async (payload) => {
  try {
    const response = await api.post("/admin/queues", payload);
    console.log("getAllQueue response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error (getAllQueue): ", error);
    throw error;
  }
};

export const shortQueue = async (data) => {
  try {
    const payload = {
      sorted_data: data,
    };
    const response = await api.post("admin/queues/sorting", payload);
    console.log("shortQueue response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error (shortQueue): ", error);
    throw error;
  }
};

export const addQueData = async (neworderid, product_id, QueueIDs) => {
  try {
    const response = await api.post("/admin/move-product-to-queue", {
      neworderid,
      product_id,
      QueueIDs,
    });
    console.log("addQueData response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error (addQueData): ", error);
    throw error;
  }
};

export const SearchQueue = async ({ keyword, queue_date, queue_number }) => {
  try {
    const response = await api.post("/admin/search-queue", {
      keyword,
      queue_date,
      queue_number,
    });
    return response.data;
  } catch (err) {
    console.error("Error searching queue:", err);
    throw err;
  }
};
export const deleteQueue = async (param) => {
  try {
    // param may be a single id, an array of ids, or an object containing ids
    let body;

    if (Array.isArray(param)) {
      // called with array directly
      body = { ids: param.map((i) => parseInt(i)) };
    } else if (param && typeof param === 'object') {
      if (Array.isArray(param.ids)) {
        body = { ids: param.ids.map((i) => parseInt(i)) };
      } else if (param.id !== undefined) {
        const id = parseInt(param.id);
        if (isNaN(id)) throw new Error('Invalid ID provided');
        body = { id };
      }
    } else {
      const id = parseInt(param);
      if (isNaN(id)) {
        throw new Error('Invalid ID provided');
      }
      body = { id };
    }

    const response = await api.post('/admin/queue/delete', body);
    console.log('deleteQueue response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (deleteQueue): ', error);
    throw error;
  }
};

export const filterQueue = async (value, page, pageSize, queue_date) => {
  try {
    const response = await api.post("/admin/queue/filter", {
      value,
      page,
      pageSize,
      queue_date,
    });
    console.log("filterQueue response: ", value, page, pageSize, queue_date);
    return response.data;
  } catch (error) {
    console.error("Error (filterQueue): ", error);
    throw error;
  }
};

export const seriesViewSearch = async (payload) => {
  try {
    const response = await api.post(
      "/admin/search-products/designview",
      payload
    );
    console.log("filterQueue response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error (filterQueue): ", error);
    throw error;
  }
};

export const getQueueByDate = async (payload) => {
  try {
    const response = await api.post("/admin/fetch-queues-by-date", payload);
    console.log("getQueueByDate response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error (getQueueByDate): ", error);
    throw error;
  }
};

// DashBoard API

export const dashBoardView = async (dateRange) => {
  try {
    let payload = {};

    // Determine the payload based on the selected date range
    switch (dateRange.range) {
      case "CurrentDate":
        payload = { filter_type: "today" };
        break;
      case "CurrentMonth":
        payload = { filter_type: "current_month" };
        break;
      case "PastMonth":
        payload = { filter_type: "past_month" };
        break;
      case "Last6Months":
        payload = { filter_type: "last_6_months" };
        break;
      case "Custom":
        if (dateRange.customDates.from && dateRange.customDates.to) {
          payload = {
            filter_type: "custom",
            start_date: dateRange.customDates.from,
            end_date: dateRange.customDates.to,
          };
        } else {
          // Default to today if custom dates aren't set
          payload = { filter_type: "today" };
        }
        break;
      default:
        payload = { filter_type: "today" };
    }

    const response = await api.post("/admin/dashboard-count", payload);
    console.log("Dashboard data response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard data: ", error);
    throw error;
  }
};


export const showProductiionChart = async (payload) => {
  try {
    const response = await api.post("/admin/processingChartData", payload);
    console.log("updateQueueStatus response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating queue status:", error);
    throw error;
  }
};

export const getProductionDetails = async (payload) => {
  try {
    const response = await api.post("/admin/graphDetailData", payload);
    console.log("getProductionDetails response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching production details:", error);
    throw error;
  }
};



export const updateQueueStatus = async (queueId, status) => {
  try {
    const response = await api.post("/admin/update-queue-status", {
      id: queueId,
      value: status,
    });
    console.log("updateQueueStatus response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating queue status:", error);
    throw error;
  }
};

export const createQueue = async (queueName) => {
  try {
    const response = await api.post("/admin/queue-list/insert", { queueName });
    // console.log("createQueue response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error creating queue:", error);
    throw error;
  }
};

export const getQueueList = async (payload) => {
  try {
    const response = await api.post("/admin/queue-list/view",  payload);
    // console.log("getQueueList response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching queue list:", error);
    throw error;
  }
};
export const updateQueueName = async (id, queueName) => {
  try {
    const response = await api.post("/admin/queue-list/update", {
      id,
      queueName,
    });
    // console.log("getQueueList response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching queue list:", error);
    throw error;
  }
};
export const EditQueueName = async (id) => {
  try {
    const response = await api.post("/admin/queue-list/edit", { id });
    // console.log("getQueueList response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching queue list:", error);
    throw error;
  }
};
export const deleteListQueue = async (id) => {
  try {
    const response = await api.post("/admin/queue-list/delete", { id });
    // console.log("getQueueList response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching queue list:", error);
    throw error;
  }
};
export const SearchListQueue = async (keyword, page, pageSize) => {
  try {
    const response = await api.post("/admin/queue-list/search", {
      keyword,
      page,
      pageSize,
    });
    // console.log("getQueueList response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching queue list:", error);
    throw error;
  }
};
export const SearchReportList = async ({
  search,
  filter,
  reportCustomDates,
}) => {
  try {
    const payload = { search };

    if (reportCustomDates?.from && reportCustomDates?.to) {
      payload.filter = "custom";
      payload.start_date = reportCustomDates.from;
      payload.end_date = reportCustomDates.to;
    } else {
      payload.filter = filter;
    }

    const response = await api.post("/admin/report/search", payload);
    return response.data;
  } catch (error) {
    console.error("Error fetching search report:", error);
    throw error;
  }
};

export const SearchItemReportList = async (search) => {
  try {
    const response = await api.post("/inventory_report_search", { search });
    // console.log("getQueueList response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching queue list:", error);
    throw error;
  }
};
 

export const getReportList = async ({
  page,
  pageSize,
  filter,
  reportCustomDates,
}) => {
  try {
    let payload = {
      page,
      pageSize,
    };

    // Apply filter type
    switch (filter) {
      case "today":
        payload.filter = "today";
        break;
      case "current_month":
        payload.filter = "current_month";
        break;
      case "past_6_months":
        payload.filter = "past_6_months";
        break;
      case "current_year":
        payload.filter = "current_year";
        break;
      case "custom":
        if (reportCustomDates?.from && reportCustomDates?.to) {
          payload.filter = "custom";
          payload.start_date = reportCustomDates.from;
          payload.end_date = reportCustomDates.to;
        } else {
          payload.filter = "today"; // fallback
        }
        break;
      default:
        payload.filter = "today";
    }

    const response = await api.post("/admin/report", payload);
    return response.data;
  } catch (error) {
    console.error("Error fetching report list:", error);
    throw error;
  }
};
export const getItemReportList = async ({
  page = 1,
  pageSize = 10,
  filter = "today",
  search,
  start_date,
  end_date,
}) => {
  try {
    const payload = {
      page,
      pageSize,
      filter,
    };

    if (search) payload.search = search;

    // Custom range: use start_date & end_date directly
    if (filter === "custom" && start_date && end_date) {
      payload.start_date = start_date;
      payload.end_date = end_date;
    }

    console.log("getItemReportList → Payload:", payload); // Debug (remove later)

    const response = await api.post("/inventory_report", payload);
    return response.data;
  } catch (error) {
    console.error("Error fetching report list:", error);
    throw error;
  }
};
 
export const getMoldReportList = async ({
  page,
  pageSize,
  filter,
  reportCustomDates,
  searchValue = "", // <-- add default
}) => {
  try {
    let payload = {
      page,
      pageSize,
      search: searchValue.trim(), // <-- include search value
    };

    // Apply filter type
    switch (filter) {
      case "today":
        payload.filter = "today";
        break;
      case "current_month":
        payload.filter = "current_month";
        break;
      case "past_6_months":
        payload.filter = "past_6_months";
        break;
      case "current_year":
        payload.filter = "current_year";
        break;
      case "custom":
        if (reportCustomDates?.from && reportCustomDates?.to) {
          payload.filter = "custom";
          payload.start_date = reportCustomDates.from;
          payload.end_date = reportCustomDates.to;
        } else {
          payload.filter = "today";
        }
        break;
      default:
        payload.filter = "today";
    }

    const response = await api.post("mold/report", payload);
    return response.data;
  } catch (error) {
    console.error("Error fetching report list:", error);
    throw error;
  }
};



export const exportReport = async (filter, customDates, search = "") => {
  try {
    let payload = { search };

    switch (filter) {
      case "today":
      case "current_month":
      case "past_6_months":
      case "current_year":
        payload = { filter, search };
        break;

      case "custom":
        if (customDates?.from && customDates?.to) {
          payload = {
            filter: "custom",
            start_date: customDates.from,
            end_date: customDates.to,
            search,
          };
        } else {
          payload = { filter: "today", search };
        }
        break;

      default:
        payload = { filter: "today", search };
    }

    const response = await api.post("/order_report", payload);
    const jsonData = response.data.production_summary;
    const reportDate = response.data.report_date || new Date().toISOString().split("T")[0];

    if (!Array.isArray(jsonData) || jsonData.length === 0) {
      alert("No data found for the selected period.");
      return false;
    }

    const sheetData = [];

    // Dynamic Title based on filter
    let title = "";
    const today = new Date(reportDate);
    const day = today.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
    const monthName = today.toLocaleString("en-US", { month: "long" });
    const year = today.getFullYear();

    switch (filter) {
      case "today":
        title = `DAILY PRODUCTION REPORT - ${day}`;
        break;
      case "current_month":
         title = `MONTHLY PRODUCTION REPORT - ${monthName} ${year}`;
        break;
      case "past_6_months":
        title = `PAST 6 MONTHS PRODUCTION REPORT`;
        break;
      case "current_year":
        title = `YEARLY PRODUCTION REPORT - ${year}`;
        break;
      case "custom":
        const from = new Date(customDates.from).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
        const to = new Date(customDates.to).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
        title = `PRODUCTION REPORT - ${from} to ${to}`;
        break;
      default:
        title = `PRODUCTION REPORT - ${day}`;
    }

    sheetData.push([title]);
    sheetData.push([]); // Empty row after title

    // Headers
    const headers = [
      "S.NO",
      "ORDER",
      "PARTY NAME",
      "DESIGN",
      "COLOUR",
      "PCS CAST",
      "DAMAGE",
      "NET",
    ];
    sheetData.push(headers);

    // Data Rows
    let hasDataBeforeTotal = false;
    jsonData.forEach((row) => {
      // Detect TOTAL or RESULT row
      if (row["COLOUR"] === "TOTAL" || row["COLOUR"] === "RESULT") {
        if (hasDataBeforeTotal) {
          sheetData.push([]); // One blank row before TOTAL/RESULT
        }
        hasDataBeforeTotal = false;
      } else {
        hasDataBeforeTotal = true;
      }

      sheetData.push([
        row["S.NO"] || "",
        row["ORDER"] || "",
        row["PARTY NAME"] || "",
        row["DESIGN"] || "",
        row["COLOUR"] || "",
        row["PCS CAST"] || "",
        row["DAMAGE"] || "",
        row["NET"] || "",
      ]);
    });

    sheetData.push([]);
    sheetData.push([
      "NOTE: LIKE IN THE ORDER TABLE IN THE QUANTITY TO BE SEEN IN SQFT AND PCS",
    ]);

    // Create worksheet
    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    // Merges: Title & Note
    ws["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }, // Title
      { s: { r: sheetData.length - 1, c: 0 }, e: { r: sheetData.length - 1, c: 7 } }, // Note
    ];

    // Column widths
    ws["!cols"] = [
      { wch: 6 },   // S.NO
      { wch: 12 },  // ORDER
      { wch: 25 },  // PARTY NAME
      { wch: 18 },  // DESIGN
      { wch: 15 },  // COLOUR
      { wch: 12 },  // PCS CAST
      { wch: 10 },  // DAMAGE
      { wch: 10 },  // NET
    ];

    // Styling
    // Title
    if (ws["A1"]) {
      ws["A1"].s = {
        font: { bold: true, sz: 16, color: { rgb: "003087" } },
        alignment: { horizontal: "center", vertical: "center" },
      };
    }

    // Headers (Row 2)
    headers.forEach((_, idx) => {
      const cell = XLSX.utils.encode_cell({ r: 2, c: idx });
      if (ws[cell]) {
        ws[cell].s = {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "003087" } },
          alignment: { horizontal: "center" },
        };
      }
    });

    // TOTAL & RESULT rows - Make them bold and highlighted
    jsonData.forEach((row, i) => {
      const rowIdx = i + 3; // +3 because: title, blank, headers
      if (row["COLOUR"] === "TOTAL" || row["COLOUR"] === "RESULT") {
        for (let c = 0; c < 8; c++) {
          const cell = XLSX.utils.encode_cell({ r: rowIdx, c });
          if (ws[cell]) {
            ws[cell].s = {
              font: { bold: true },
              fill: { fgColor: { rgb: row["COLOUR"] === "TOTAL" ? "FFFF00" : "E6F3FF" } },
              alignment: { horizontal: c >= 5 ? "center" : "left" },
            };
          }
        }
      }
    });

    // Note
    const noteCell = XLSX.utils.encode_cell({ r: sheetData.length - 1, c: 0 });
    if (ws[noteCell]) {
      ws[noteCell].s = { font: { bold: true, italic: true }, alignment: { horizontal: "center" } };
    }

    // Create workbook and download
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Production Report");
    XLSX.writeFile(wb, `${title.replace(/[^a-zA-Z0-9 ]/g, "_")}.xlsx`);

    return true;
  } catch (error) {
    console.error("Error exporting report:", error);
    alert("Failed to export report. Please try again.");
    return false;
  }
};

export const exportItemReport = async (filter, customDates, search = "") => {
  try {
    // 1. Prepare payload (same logic as production report)
    let payload = { search };
    switch (filter) {
      case "today":
      case "current_month":
      case "past_6_months":
      case "current_year":
        payload = { filter, search };
        break;
      case "custom":
        if (customDates?.from && customDates?.to) {
          payload = {
            filter: "custom",
            start_date: customDates.from,
            end_date: customDates.to,
            search,
          };
        } else {
          payload = { filter: "today", search };
        }
        break;
      default:
        payload = { filter: "today", search };
    }

    // 2. Fetch data
    const response = await api.post("/inventory_report", payload);
    const jsonData = response.data.data || [];
    const reportDate = response.data.report_date || new Date().toISOString().split("T")[0];

    if (!Array.isArray(jsonData) || jsonData.length === 0) {
      alert("No inventory data found for the selected period.");
      return false;
    }

    const sheetData = [];

    // Dynamic Title based on filter
    let title = "";
    const today = new Date(reportDate);
    const day = today.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
    const monthName = today.toLocaleString("en-US", { month: "long" });
    const year = today.getFullYear();

    switch (filter) {
      case "today":
        title = `INVENTORY REPORT - ${day}`;
        break;
      case "current_month":
        title = `INVENTORY REPORT - ${monthName} ${year}`;
        break;
      case "past_6_months":
        title = `INVENTORY REPORT - PAST 6 MONTHS`;
        break;
      case "current_year":
        title = `INVENTORY REPORT - ${year}`;
        break;
      case "custom":
        const from = new Date(customDates.from).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
        const to = new Date(customDates.to).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
        title = `INVENTORY REPORT - ${from} to ${to}`;
        break;
      default:
        title = `INVENTORY REPORT - ${day}`;
    }

    sheetData.push([title]);
    sheetData.push([]); // Empty row

    // Headers
    const headers = ["S.NO", "ITEM NAME", "QUANTITY", "ADDITIONS", "CONSUMPTION"];
    sheetData.push(headers);

    // Data rows
    jsonData.forEach((item, index) => {
      sheetData.push([
        (index + 1).toString(),
        item.inventory_name || "",
        item.inventory_quantity || "0",
        item.totalquantityplus || "0",
        item.totalquantityminus || "0",
      ]);
    });

    sheetData.push([]);
    sheetData.push(["NOTE: THIS IS A SYSTEM GENERATED INVENTORY REPORT."]);

    // Create worksheet
    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    // Merges
    ws["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 4 } }, // Title
      { s: { r: sheetData.length - 1, c: 0 }, e: { r: sheetData.length - 1, c: 4 } }, // Note
    ];

    // Column widths
    ws["!cols"] = [
      { wch: 8 },   // S.NO
      { wch: 35 },  // ITEM NAME (wider for long names)
      { wch: 15 },  // QUANTITY
      { wch: 15 },  // ADDITIONS
      { wch: 15 },  // CONSUMPTION
    ];

    // Styling: Title
    if (ws["A1"]) {
      ws["A1"].s = {
        font: { bold: true, sz: 16, color: { rgb: "003087" } },
        alignment: { horizontal: "center", vertical: "center" },
      };
    }

    // Styling: Headers
    headers.forEach((_, idx) => {
      const cell = XLSX.utils.encode_cell({ r: 2, c: idx });
      if (ws[cell]) {
        ws[cell].s = {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "003087" } },
          alignment: { horizontal: "center" },
        };
      }
    });

    // Styling: Data cells (quantity columns centered)
    for (let i = 0; i < jsonData.length; i++) {
      const rowIdx = i + 3;
      // Quantity, Additions, Consumption → center align
      [2, 3, 4].forEach(col => {
        const cell = XLSX.utils.encode_cell({ r: rowIdx, c: col });
        if (ws[cell]) {
          ws[cell].s = { alignment: { horizontal: "center" } };
        }
      });
    }

    // Styling: Note
    const noteCell = XLSX.utils.encode_cell({ r: sheetData.length - 1, c: 0 });
    if (ws[noteCell]) {
      ws[noteCell].s = {
        font: { bold: true, italic: true },
        alignment: { horizontal: "center" },
      };
    }

    // Create workbook & download
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Inventory Report");
    XLSX.writeFile(wb, `${title.replace(/[^a-zA-Z0-9 ]/g, "_")}.xlsx`);

    return true;
  } catch (error) {
    console.error("Error exporting inventory report:", error);
    alert("Failed to export inventory report. Please try again.");
    return false;
  }
};

export const exportmoldReport = async (filter, customDates, search = "") => {
  try {
    let payload = { search };
    switch (filter) {
      case "today":
      case "current_month":
      case "past_6_months":
      case "current_year":
        payload = { filter, search };
        break;
      case "custom":
        if (customDates?.from && customDates?.to) {
          payload = {
            filter: "custom",
            start_date: customDates.from,
            end_date: customDates.to,
            search,
          };
        } else {
          payload = { filter: "today", search };
        }
        break;
      default:
        payload = { filter: "today", search };
    }

    const response = await api.post("/mold/report", payload);
    const jsonData = response.data.data || [];
    const reportDate = response.data.report_date || new Date().toISOString().split("T")[0];

    if (!Array.isArray(jsonData) || jsonData.length === 0) {
      alert("No mold data found for the selected period.");
      return false;
    }

    const sheetData = [];

    // Dynamic Title
    let title = "";
    const today = new Date(reportDate);
    const day = today.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
    const monthName = today.toLocaleString("en-US", { month: "long" });
    const year = today.getFullYear();

    switch (filter) {
      case "today":
        title = `MOLD REPORT - ${day}`;
        break;
      case "current_month":
        title = `MOLD REPORT - ${monthName} ${year}`;
        break;
      case "past_6_months":
        title = `MOLD REPORT - PAST 6 MONTHS`;
        break;
      case "current_year":
        title = `MOLD REPORT - ${year}`;
        break;
      case "custom":
        const from = new Date(customDates.from).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
 ScreenReader: true
        });
        const to = new Date(customDates.to).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
        title = `MOLD REPORT - ${from} to ${to}`;
        break;
      default:
        title = `MOLD REPORT - ${day}`;
    }

    sheetData.push([title]);
    sheetData.push([]);
    sheetData.push([
      "S.NO",
      "MOLD NAME",
      "INITIAL QUANTITY",
      "REMAINING QUANTITY",
      "ADDITIONS",
      "CONSUMPTION",
    ]);

    jsonData.forEach((mold, index) => {
      sheetData.push([
        (index + 1).toString(),
        mold.mold_name || "",
        mold.initial_quantity || "0",
        mold.remaining_quantity || "0",
        mold.totalquantityplus || "0",
        mold.totalquantityminus || "0",
      ]);
    });

    sheetData.push([]);
    sheetData.push(["NOTE: THIS IS A SYSTEM GENERATED MOLD REPORT."]);

    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    ws["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 5 } },
      { s: { r: sheetData.length - 1, c: 0 }, e: { r: sheetData.length - 1, c: 5 } },
    ];

    ws["!cols"] = [
      { wch: 8 },
      { wch: 30 },
      { wch: 18 },
      { wch: 20 },
      { wch: 15 },
      { wch: 15 },
    ];

    // Title style
    if (ws["A1"]) {
      ws["A1"].s = {
        font: { bold: true, sz: 16, color: { rgb: "003087" } },
        alignment: { horizontal: "center", vertical: "center" },
      };
    }

    // Header style
    for (let c = 0; c < 6; c++) {
      const cell = XLSX.utils.encode_cell({ r: 2, c });
      if (ws[cell]) {
        ws[cell].s = {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "003087" } },
          alignment: { horizontal: "center" },
        };
      }
    }

    // Center numeric columns
    for (let i = 0; i < jsonData.length; i++) {
      const rowIdx = i + 3;
      [2, 3, 4, 5].forEach(col => {
        const cell = XLSX.utils.encode_cell({ r: rowIdx, c: col });
        if (ws[cell]) ws[cell].s = { alignment: { horizontal: "center" } };
      });
    }

    // Note style
    const noteCell = XLSX.utils.encode_cell({ r: sheetData.length - 1, c: 0 });
    if (ws[noteCell]) {
      ws[noteCell].s = {
        font: { bold: true, italic: true },
        alignment: { horizontal: "center" },
      };
    }

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Mold Report");
    XLSX.writeFile(wb, `${title.replace(/[^a-zA-Z0-9 ]/g, "_")}.xlsx`);

    return true;
  } catch (error) {
    console.error("Error exporting mold report:", error);
    alert("Failed to export mold report. Please try again.");
    return false;
  }
};

export const editProductItems = async (productItme) => {
  try {
    const response = await api.post(`/update-item`, productItme);
    console.log("colorResponse:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating design:", error);
    throw error;
  }
};

export const deleteProductItmes = async (order_id, product_id) => {
  try {
    // console.log("id: ", id);
    const response = await api.post(`/delete-itme`, { order_id, product_id });
    console.log("response delete: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (updateUser): ", err);
    throw err;
  }
};

// Order Api for Customer portal

export const getCustomerOrders = async (id) => {
  try {
    const response = await api.post("customer/order", { cust_id: id });
    console.log("response delete: ", response);
    return response.data;
  } catch (error) {
    console.log("Error (updateUser): ", error);
    throw error;
  }
};
export const changeCustomerPassword = async (id, newpassword) => {
  try {
    const response = await api.post("customer/change-password", {
      _id: id,
      newpassword,
    });
    console.log("response delete: ", response);
    return response.data;
  } catch (error) {
    console.log("Error (updateUser): ", error);
    throw error;
  }
};

export const addCostomerOrder = async (OrderData) => {
  try {
    const response = await api.post("customer/add/order", OrderData);
    console.log("customer   order create", response.data);
    return response.data;
  } catch (error) {
    console.log("Error (add order): ", error);
    throw error;
  }
};

export const UpdateCostomerOrder = async (OrderData) => {
  try {
    const response = await api.post("update/customer/order", OrderData);
    console.log("customer   order create", response.data);
    return response.data;
  } catch (error) {
    console.log("Error (add order): ", error);
    throw error;
  }
};


export const getCustomerOrderDetailsList = async () => {
  try {
    const response = await api.post("admin/customer_view_order",  );
    console.log("response getCustomerOrderDetailsList: ", response);
    return response.data;
  } catch (error) {
    console.log("Error (getCustomerOrderDetailsList): ", error);
    throw error;
  }
};


export const changeNewOrderStaus = async (neworderid) => {
  try {
    const response = await api.post("admin/changestatus",neworderid  );
    console.log("response changeNewOrderStaus: ", response);
    return response.data;
  } catch (error) {
    console.log("Error (changeNewOrderStaus): ", error);
    throw error;
  }
};
export const EditCustomerOrder = async (neworderid) => {
  try {
    const response = await api.post("view/customer/order", {neworderid:neworderid}  );

    console.log("response changeNewOrderStaus: ", response);
    return response.data;
  } catch (error) {
    console.log("Error (changeNewOrderStaus): ", error);
    throw error;
  }
};


export const DeleteCustomerOrder = async (neworderid , product_id) => {
  try {
    const response = await api.post("delete/customer/order", {neworderid,product_id}  );

    console.log("response changeNewOrderStaus: ", response);
    return response.data;
  } catch (error) {
    console.log("Error (changeNewOrderStaus): ", error);
    throw error;
  }
};

export const searchSingleItems = async (payload) => {
  try {
    const response = await api.post("admin/searchitems", payload  );
    console.log("response searchSingleItems: ", response);
    return response.data;
  } catch (error) {
    console.log("Error (searchSingleItems): ", error);
    throw error;
  }
}
export const SearchItmeCostomerOrder = async (payload) => {
  try {
    const response = await api.post("search/customer/order", payload  );
    console.log("response searchSingleItems: ", response);
    return response.data;
  } catch (error) {
    console.log("Error (searchSingleItems): ", error);
    throw error;
  }
}
export const ViewAllDesign = async (page,pageSize) => {
  try {
    const response = await api.post("view_design", {page,pageSize}  );
    console.log("response view_design: ", response);
    return response.data;
  } catch (error) {
    console.log("Error (view_design): ", error);
    throw error;
  }
}
export const SearchAllDesign = async (search,page,pageSize) => {
  try {
    const response = await api.post("search_design", {search,page,pageSize}  );
    console.log("response search_design: ", response);
    return response.data;
  } catch (error) {
    console.log("Error (search_design): ", error);
    throw error;
  }
}




export const exportOrders = async (filter, customDates, search = "") => {
  try {
    let payload = { search }; // initialize with search

    switch (filter) {
      case "today":
      case "current_month":
      case "past_6_months":
      case "current_year":
        payload = { filter, search };
        break;

      case "custom":
        if (customDates?.from && customDates?.to) {
          payload = {
            filter: "custom",
            start_date: customDates.from,
            end_date: customDates.to,
            search,
          };
        } else {
          payload = { filter: "today", search };
        }
        break;

      default:
        payload = { filter: "today", search };
    }

    const response = await api.post("/admin/order/exportOrders", payload);
    const jsonData = response.data.data;
    const reportDate = new Date().toISOString().split("T")[0];

    if (!Array.isArray(jsonData) || jsonData.length === 0) {
      console.warn("No data to export.");
      return false;
    }

    const sheetData = [];

    // Title
    sheetData.push([`ORDER REPORT - ${filter === "today" ? "TODAY" : filter.toUpperCase()}`]);
    sheetData.push([]);

    // Headers
    const headers = [
      "No.",
      "ID",
      "Customer  ",
      "Design  ",
      "Color  ",
      "QTY (Sqft)",
      "QTY (Pieces)",
      "Remaining Quantity",
      "Progress",
      "Order Date"
    ];
    sheetData.push(headers);

    // Data Rows
    jsonData.forEach((row) => {
      sheetData.push([
        row["No"] || "",
        row["ID"] || "",
        row["Customer Name"] || "",
        row["Design Name"] || "",
        row["Color Name"] || "",
        row["sqft"] || "", // Use sqft for QTY (Sqft)
        row["QTY"] || "",  // Use QTY for Pieces
        row["Remaining Quantity"] || "",
        row["Progress"] || "",
        row["Order Date"] || "",
      ]);
    });

    // Summary information
    sheetData.push([]);
    // sheetData.push(["Total Records:", response.data.totalRecords]);
    // sheetData.push(["Page:", `${response.data.page} of ${response.data.totalPages}`]);
    // sheetData.push(["Page Size:", response.data.pageSize]);

    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    
    // Merge title cell
    ws["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }
    ];
    
    // Set column widths
    ws["!cols"] = [
      { wch: 5 },   // No.
      { wch: 10 },   // ID
      { wch: 20 },   // Customer Name
      { wch: 15 },   // Design Name
      { wch: 15 },   // Color Name
      { wch: 12 },   // QTY (Sqft)
      { wch: 12 },   // QTY (Pieces)
      { wch: 15 },   // Remaining Quantity
      { wch: 10 },   // Progress
      { wch: 12 }    // Order Date
    ];

    // Style title cell
    ws["A1"].s = {
      font: { bold: true, sz: 14 },
      alignment: { horizontal: "center" }
    };

    // Style headers
    headers.forEach((_, colIdx) => {
      const cellRef = XLSX.utils.encode_cell({ r: 2, c: colIdx });
      if (ws[cellRef]) {
        ws[cellRef].s = { font: { bold: true } };
      }
    });

    // Style summary information
    for (let i = sheetData.length - 3; i < sheetData.length; i++) {
      const cellRef = XLSX.utils.encode_cell({ r: i, c: 0 });
      if (ws[cellRef]) {
        ws[cellRef].s = { font: { bold: true } };
      }
    }

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Orders");
    
    const fileName = `Order_Report_${filter === "today" ? "Today" : filter}_${reportDate}.xlsx`;
    XLSX.writeFile(wb, fileName, { cellStyles: true });

    return true;
  } catch (error) {
    console.error("Error exporting orders:", error);
    throw error;
  }
};





export const deleteDesigne = async (payload) => {
  try {
    // console.log("id: ", id);
    const response = await api.post(`/delete_design`, payload);
    console.log("response delete: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (updateUser): ", err);
    throw err;
  }
};
export const EditUpdateQuaintity  = async (payload) => {
  try {
    // console.log("id: ", id);
    const response = await api.post(`/admin/order/product/updateProductionHistory`, payload);
    console.log("response update quaintity : ", response);
    return response.data;
  } catch (err) {
    console.log("Error (updateUser): ", err);
    throw err;
  }
};



export const downlaodDashboardProductionReport = async (payload)=>{
  try {
    // console.log("id: ", id);
    const response = await api.post(`/admin/getProductionByEntryDate`, payload);
    console.log("response download production report: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (downlaodDashboardProductionReport): ", err);
    throw err;
  }
}




export const getShade = async ()=>{
  try {
     
    const response = await api.post(`/get_shades`);
    console.log("response get shade: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (getShade): ", err);
    throw err;
  }
}

export const getBetch = async (payload)=>{
  try {
     
    const response = await api.post(`/batch/all`,payload);
    console.log("response get shade: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (getShade): ", err);
    throw err;
  }
}
export const getMachine = async ()=>{
  try {
     
    const response = await api.get(`/admin/machine`);
    console.log("response get machine: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (getMachine): ", err);
    throw err;
  }
}



export const CreateShade = async (payload)=>{
  try {
     
    const response = await api.post(`/create_shade`, payload);
    console.log("response get shade: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (create_shade): ", err);
    throw err;
  }
}
export const CreateBatch = async (payload)=>{
  try {
     
    const response = await api.post(`/batch/create`, payload);
    console.log("response get shade: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (create_shade): ", err);
    throw err;
  }
}
export const CreateMachine = async (payload)=>{
  try {
     
    const response = await api.post(`/admin/add_machine`, payload);
    console.log("response get machine: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (create_machine): ", err);
    throw err;
  }
}



export const updateShade = async (payload)=>{
  try {
     
    const response = await api.post(`/update_shade`, payload);
    console.log("response get shade: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (update_shade): ", err);
    throw err;
  }
}

export const updateBatch = async (payload)=>{
  try {
     
    const response = await api.post(`/batch/update`, payload);
    console.log("response get shade: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (update_batch): ", err);
    throw err;
  }
}
export const updateMachine = async (payload)=>{
  try {
     
    const response = await api.post(`/admin/update_machine`, payload);
    console.log("response get machine: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (update_machine): ", err);
    throw err;
  }
}

export const EditShade = async (id)=>{
  try {
     
    const response = await api.post(`/get_single_shade`, {id});
    console.log("response get shade: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (get_single_shade): ", err);
    throw err;
  }
}
export const EditBatch = async (id)=>{
  try {
     
    const response = await api.post(`/batch/single`, {id});
    console.log("response get batch: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (get_single_batch): ", err);
    throw err;
  }
}
export const EditMachine = async (id)=>{
  try {
     
    const response = await api.post(`/admin/edit_machine`, {id});
    console.log("response get machine: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (get_single_machine): ", err);
    throw err;
  }
}


export const DeleteShade = async (id)=>{
  try {
     
    const response = await api.post(`/delete_shade`, {id});
    console.log("response get shade: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (delete_shade): ", err);
    throw err;
  }
}
export const DeleteBatch = async (id)=>{
  try {
     
    const response = await api.post(`/batch/delete`, {id});
    console.log("response get batch: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (delete_batch): ", err);
    throw err;
  }
}

export const getDeletedBatches = async (payload) => {
  try {
    const response = await api.post(`/batch/deletedBatch`, payload);
    console.log("response get deleted batches: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (get_deleted_batches): ", err);
    throw err;
  }
}

export const restoreBatch = async (id) => {
  try {
    const response = await api.post(`/batch/restore`, { id });
    console.log("response restore batch: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (restore_batch): ", err);
    throw err;
  }
}

export const permanentDeleteBatch = async (id) => {
  try {
    const response = await api.post(`/batch/permanent-delete`, { id });
    console.log("response permanent delete batch: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (permanent_delete_batch): ", err);
    throw err;
  }
}

export const DeleteMachine = async (id)=>{
  try {
     
    const response = await api.post(`/admin/delete_machine`, {id});
    console.log("response get machine: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (delete_machine): ", err);
    throw err;
  }
}


export const uploadProductImage = async (productData) => {
  try {
    const response = await api.post(`/admin/updateDispatchImage`, productData);
    console.log("Response from uploadProductImage: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (upload_product_image): ", err);
    throw err;
  }
};


export const deleteProductImage = async (payload) => {
  try {
    const response = await api.post(`/admin/deleteDispatchAttachment`, payload);
    console.log("Response from deleteProductImage: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (deleteProductImage): ", err);
    throw err;
  }
};

export const ViewProductImage = async (payload) => {
  try {
    const response = await api.post(`/admin/viewOrderImages`, payload);
    console.log("Response from deleteProductImage: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (deleteProductImage): ", err);
    throw err;
  }
};

export const ViewOrderProductImage = async (payload) => {
  try {
    const response = await api.post(`/view-order-images`, payload);
    console.log("Response from deleteProductImage: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (deleteProductImage): ", err);
    throw err;
  }
};

export const ViewDispatchProductImage = async (payload) => {
  try {
    const response = await api.post(`/admin/dispatchIimagePreview`, payload);
    console.log("Response from deleteProductImage: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (deleteProductImage): ", err);
    throw err;
  }
};
export const convertDispatchProductImageInToBase64 = async (payload) => {
  try {
    const response = await api.post(`/admin/convertDispatchBase64ToFile`, payload);
    console.log("Response from deleteProductImage: ", response);
    return response.data;
  } catch (err) {
    console.log("Error (deleteProductImage): ", err);
    throw err;
  }
};

// Notes API functions
export const createNote = async (noteData) => {
  try {
    const response = await api.post(`/notes/create`, noteData);
    return response.data;
  } catch (err) {
    console.log("Error (createNote): ", err);
    throw err;
  }
};

export const getNotesList = async (pageSize, page) => {
  try {
    const response = await api.post(`notes/view`, {pageSize,page});
    return response.data;
  } catch (err) {
    console.log("Error (getNotesList): ", err);
    throw err;
  }
};

export const getNoteById = async (id) => {
  try {
    const response = await api.post(`/notes/edit`,{note_id: id});
    return response.data;
  } catch (err) {
    console.log("Error (getNoteById): ", err);
    throw err;
  }
};

export const updateNote = async ( noteData) => {
  try {
    const response = await api.post(`/notes/update`, noteData);
    return response.data;
  } catch (err) {
    console.log("Error (updateNote): ", err);
    throw err;
  }
};

export const deleteNote = async (id) => {
  try {
    const response = await api.post(`/notes/delete`,{note_id:id});
    return response.data;
  } catch (err) {
    console.log("Error (deleteNote): ", err);
    throw err;
  }
};

export const getOrderListForNotes = async () => {
  try {
    const response = await api.post(`/notes/order_list`);
    return response.data;
  } catch (err) {
    console.log("Error (getOrderListForNotes): ", err);
    throw err;
  }
};

export const searchNotes = async (searchQuery, pageSize, page) => {
  try {
    const response = await api.post(
      `/notes/search`,
      {
        query:searchQuery,
        pageSize,
        page

      }
    );
    return response.data;
  } catch (err) {
    console.log("Error (searchNotes): ", err);
    throw err;
  }
};

export const getDashboardNotes = async (dateRange) => {
  try {
    let payload = {};

    // Get user data from localStorage
    const userStr = localStorage.getItem("user");
    let department = null;
    let userId = null;
    
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        department = user.department || null;
        userId = user._id || null; // Extract the _id from user data
      } catch (parseError) {
        console.log("Error parsing user from localStorage:", parseError);
      }
    }

    // Build payload based on dateRange.range (not dateRange.filter)
    const rangeType = dateRange?.range || dateRange?.filter;
    
    switch (rangeType) {
      case "CurrentDate":
      case "today":
        payload = { filter_type: "today" };
        break;
      case "Yesterday":
      case "yesterday":
        payload = { filter_type: "yesterday" };
        break;
      case "Last7Days":
      case "last7days":
        payload = { filter_type: "last7days" };
        break;
      case "Last30Days":
      case "last30days":
        payload = { filter_type: "last30days" };
        break;
      case "CurrentMonth":
      case "thisMonth":
        payload = { filter_type: "thisMonth" };
        break;
      case "LastMonth":
      case "lastMonth":
        payload = { filter_type: "lastMonth" };
        break;
      case "Custom":
      case "custom":
        if (dateRange?.customDates?.from && dateRange?.customDates?.to) {
          payload = {
            filter_type: "custom",
            start_date: dateRange.customDates.from,
            end_date: dateRange.customDates.to,
          };
        } else {
          payload = { filter_type: "today" };
        }
        break;
      default:
        payload = { filter_type: "today" };
    }

    // Add department to payload if available
    if (department) {
      payload.department = department;
    }

    // Add userId to payload if available
    if (userId) {
      payload.userId = userId; // This will send _id: 44 in your case
    }

    console.log("getDashboardNotes payload:", payload);
    const response = await api.post("/notes/dashboardNotes", payload);
    console.log("Dashboard notes response: ", response.data);
    return response.data;
  } catch (err) {
    console.log("Error (getDashboardNotes): ", err);
    throw err;
  }
};
export const updateChecklist = async (data) => {
  try {
    const response = await api.post(`/notes/update-checklist`, data);
    console.log("Update checklist response: ", response.data);
    return response.data;
  } catch (err) {
    console.log("Error (updateChecklist): ", err);
    throw err;
  }
};

export const deleteProductionHistory  = async (payload) => {
  try {
    // console.log("id: ", id);
    const response = await api.post(`/admin/order/product/deleteProductionHistory`, payload);
    console.log("response update quaintity : ", response);
    return response.data;
  } catch (err) {
    console.log("Error (updateUser): ", err);
    throw err;
  }
};

// update Order Dispatch Date (updates across multiple collections)
export const updateOrderDispatchDate = async (payload) => {
  try {
 
    const response = await api.post("/admin/update-order-dispatch-date", payload);
    console.log("updateOrderDispatchDate response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error (updateOrderDispatchDate): ", error?.response?.data || error);
    throw error;
  }
};

// Create Delivery Slip
export const createDeliverySlip = async (data) => {
  try {
    const response = await api.post('/admin/delivery-slip', data);
    console.log('createDeliverySlip response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (createDeliverySlip): ', error);
    throw error;
  }
};

// Get Delivery Slips (listing)
export const getDeliverySlips = async (params = {}) => {
  try {
    const response = await api.post('/admin/delivery-slips-list', { params });
    console.log('getDeliverySlips response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (getDeliverySlips): ', error?.response?.data || error);
    throw error;
  }
};

export const getCustomerDeliverySlips = async (payload) => {
  try {
    const response = await api.post('admin/customer/delivery-slip', payload);
    console.log('getDeliverySlips response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (getDeliverySlips): ', error?.response?.data || error);
    throw error;
  }
};

// Get single delivery slip
export const getDeliverySlip = async (id) => {
  try {
    const response = await api.post('/admin/delivery-slip/get', { _id: id });
    console.log('getDeliverySlip response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (getDeliverySlip): ', error?.response?.data || error);
    throw error;
  }
};

// Update delivery slip
export const updateDeliverySlip = async (payload) => {
  try {
    const response = await api.post('/admin/delivery-slip/update', payload);
    console.log('updateDeliverySlip response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (updateDeliverySlip): ', error?.response?.data || error);
    throw error;
  }
};

// Delete delivery slip (soft delete)
export const deleteDeliverySlip = async (id) => {
  try {
    const response = await api.post('/admin/delivery-slip/delete', { _id: id });
    console.log('deleteDeliverySlip response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (deleteDeliverySlip): ', error?.response?.data || error);
    throw error;
  }
};

// Export delivery slip to PDF (returns blob)
export const exportDeliverySlipPdf = async (id) => {
  try {
    const response = await api.post('/admin/delivery-slip/export', { _id: id }, { responseType: 'blob', headers: { Accept: 'application/json' } });
    console.log('exportDeliverySlipPdf response received for id:', id);
    return response;
  } catch (error) {
    console.error('Error (exportDeliverySlipPdf): ', error?.response?.data || error);
    throw error;
  }
};

// Get logs for an order. The backend accepts the route param `orderId` and
// an optional `neworderid` (or `new_order_id`) as a query param.
export const getOrderLogs = async (orderId, neworderid, changeReqId = null) => {
  try {
    // Backend expects the identifier in the request body (POST /admin/order-logs).
    // Send `id`, `new_order_id`, and `neworderid` so the server can match any shape.
    const identifier = neworderid || orderId;
    if (!identifier && !changeReqId) {
      throw new Error('getOrderLogs requires `orderId`, `neworderid`, or `changeReqId`.');
    }

    // `id` should be the _id of the order change request when provided.
    const payload = {
      id: changeReqId || identifier,
      new_order_id: identifier || undefined,
      neworderid: identifier || undefined,
    };

    const response = await api.post('/admin/order-logs', payload);
    console.log('getOrderLogs response: ', response.data);
    return response.data;
  } catch (err) {
    console.error('Error (getOrderLogs): ', err);
    throw err;
  }
};

// Pin / Unpin inventory item
export const pinInventory = async (master_id, id, pinned = true) => {
  try {
    const response = await api.post(`/admin/pin_inventory`, {
      master_id,
      id,
      pinned,
    });
    console.log("pinInventory response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error pinning inventory:", error);
    throw error;
  }
};



export const addShedRack = async (payload) => {
  try {
    const response = await api.post('/shed/CreateRack_shed', payload);
    console.log('addShedRack response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (addShedRack): ', error?.response?.data || error);
    throw error;
  }
};

export const getShedRack = async () => {
  try {
    const response = await api.post('/shed/get_shed');
    console.log('get shed response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (get shed): ', error?.response?.data || error);
    throw error;
  }
};
export const deleteShedRack = async (id) => {
  try {
    const response = await api.post('/shed/delete',{id});
    console.log('get shed response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (get shed): ', error?.response?.data || error);
    throw error;
  }
};
export const getSingleShedRack = async (id) => {
  try {
    const response = await api.post('/shed/get_single_shed',{id});
    console.log('get shed response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (get shed): ', error?.response?.data || error);
    throw error;
  }
};
export const updateShedRack = async (payload) => {
  try {
    const response = await api.post('/shed/update',payload);
    console.log('get shed response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (get shed): ', error?.response?.data || error);
    throw error;
  }
};
export const getProcess = async () => {
  try {
    const response = await api.post('/rackprocesses-view');
    console.log('get shed response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (get shed): ', error?.response?.data || error);
    throw error;
  }
};
export const CreateProcess = async (payload) => {
  try {
    const response = await api.post('/rackprocesses-add',payload);
    console.log('get shed response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (get shed): ', error?.response?.data || error);
    throw error;
  }
};
export const updateProcess = async (payload) => {
  try {
    const response = await api.post('/rackprocesses-update',payload);
    console.log('get shed response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (get shed): ', error?.response?.data || error);
    throw error;
  }
};
export const DeleteProcess = async (id) => {
  try {
    const response = await api.post('/rackprocesses-delete',{id});
    console.log('get shed response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (get shed): ', error?.response?.data || error);
    throw error;
  }
};

export const getOrderStatus = async () => {
  try {
    const response = await api.post('/orderstatuses-view');
    console.log('get order status response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (get order status): ', error?.response?.data || error);
    throw error;
  }
};

export const CreateOrderStatus = async (payload) => {
  try {
    const response = await api.post('/orderstatuses-add', payload);
    console.log('create order status response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (create order status): ', error?.response?.data || error);
    throw error;
  }
};

export const updateOrderStatusMaster = async (payload) => {
  try {
    const response = await api.post('/orderstatuses-update', payload);
    console.log('update order status response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (update order status): ', error?.response?.data || error);
    throw error;
  }
};

export const DeleteOrderStatus = async (id) => {
  try {
    const response = await api.post('/orderstatuses-delete', { id });
    console.log('delete order status response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (delete order status): ', error?.response?.data || error);
    throw error;
  }
};

export const viewRackData = async () => {
  try {
    const response = await api.post('/racks');
    console.log('add rack response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (add rack): ', error?.response?.data || error);
    throw error;
  }
};

export const addRackData = async (payload) => {
  try {
    const response = await api.post('/add/racks',payload);
    console.log('add rack response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (add rack): ', error?.response?.data || error);
    throw error;
  }
};

export const updateRackData = async (payload) => {
  try {
    const response = await api.post('/racks/update',payload);
    console.log('add rack response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (add rack): ', error?.response?.data || error);
    throw error;
  }
};

export const editRackData = async (id) => {
  try {
    const response = await api.post('/racks/edit',{id});
    console.log('add rack response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (add rack): ', error?.response?.data || error);
    throw error;
  }
};

export const deleteRackData = async (id) => {
  try {
    const response = await api.post('/racks/delete',{id});
    console.log('add rack response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (add rack): ', error?.response?.data || error);
    throw error;
  }
};



export const assignRacks = async (payload) => {
  try {
    const response = await api.post('/racks/assignRack',payload);
    console.log('add rack response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (add rack): ', error?.response?.data || error);
    throw error;
  }
};
export const updateRackStatus = async (payload) => {
  try {
    const response = await api.post('/racks/updateRackStatus',payload);
    console.log('add rack response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (add rack): ', error?.response?.data || error);
    throw error;
  }
};
export const removeTilesFromRack = async (payload) => {
  try {
    const response = await api.post('/racks/manageRackTiles',payload);
    console.log('add rack response: ', response.data);
    return response.data;
  } catch (error) {
    console.error('Error (add rack): ', error?.response?.data || error);
    throw error;
  }
};